"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var POINTS = {
  xs: 0,
  sm: 544,
  md: 768,
  lg: 992,
  xl: 1200
};

var getClassName = function getClassName(breakpoints) {
  if (breakpoints == null || (0, _typeof2.default)(breakpoints) !== 'object') return '';
  return Object.keys(breakpoints).map(function (screenSize) {
    var value = breakpoints[screenSize];

    if (typeof value === 'number') {
      return value === 0 ? "responsive-" + screenSize + "-hide" : "responsive-" + screenSize + "-show";
    } else if (typeof value === 'boolean') {
      return value ? "responsive-" + screenSize + "-show" : "responsive-" + screenSize + "-hide";
    } else {
      return '';
    }
  }).join(' ');
};

var getStyledComponent = function getStyledComponent(breakpoints) {
  var styles = Object.keys(breakpoints).map(function (screenSize) {
    var value = breakpoints[screenSize];
    return "\n        @media screen and (min-width: " + POINTS[screenSize] + "px) {\n          & { " + value + " }\n        }\n      ";
  }).join(' ');
  return _styledComponents.default.div.withConfig({
    displayName: "UIResponsiveComponent",
    componentId: "tjzswl-0"
  })(_templateObject(), styles);
};

var UIResponsiveComponent = function UIResponsiveComponent(_ref) {
  var children = _ref.children,
      display = _ref.display,
      styles = _ref.styles;

  if (styles !== null && (0, _typeof2.default)(styles) === 'object') {
    var Component = getStyledComponent(styles);
    return _react.default.createElement(Component, {
      className: getClassName(display)
    }, children);
  }

  return _react.default.createElement("div", {
    className: getClassName(display)
  }, children);
};

UIResponsiveComponent.propTypes = {
  display: _propTypes.default.shape({
    xs: _propTypes.default.PropTypes.boolean,
    sm: _propTypes.default.PropTypes.boolean,
    md: _propTypes.default.PropTypes.boolean,
    lg: _propTypes.default.PropTypes.boolean,
    xl: _propTypes.default.PropTypes.boolean
  }),
  children: _propTypes.default.object,
  styles: _propTypes.default.shape({
    xs: _propTypes.default.string,
    sm: _propTypes.default.string,
    md: _propTypes.default.string,
    lg: _propTypes.default.string,
    xl: _propTypes.default.string
  })
};
var _default = UIResponsiveComponent;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/UIResponsiveComponent.js
// module id = 206
// module chunks = 209 210 211 212